import {env} from 'next-runtime-env';

const NEXT_PUBLIC_RUNTIME_ENV = env('NEXT_PUBLIC_RUNTIME_ENV');

// * inspect the img src of the sticker in CMS
const getImage = (imageName: string): string => {
  const imageUrls = {
    production: {
      waterBucket: '/upload/file/diamondItem/image/b75d257a-489b-4b2b-9933-a92d04c8feea.png',
      bomb: '/upload/file/diamondItem/image/4ddb1e16-a28f-46bc-a694-5a6765d87593.png',
      poop: '/upload/file/diamondItem/image/c3aad0c9-3b3e-405b-acfc-51ae14462f24.png',
      jetFighter: '/upload/file/diamondItem/image/db62f083-b70b-4b97-a707-77f3a756e9f0.png',
      smoke: '/upload/file/diamondItem/image/3dfddadb-20ce-4f4e-9f35-8c63574bf297.png',
    },
    staging: {
      waterBucket: '/upload/file/diamondItem/image/e04954bc-ef24-49ef-b431-bc4bae703277.png',
      bomb: '/upload/file/diamondItem/image/b1b905b1-086c-478f-a73a-bf15f125586b.png',
      poop: '/upload/file/diamondItem/image/eff98a22-e5ec-4d39-9307-8fdf1207324c.png',
      jetFighter: '/upload/file/diamondItem/image/7a689cca-7adc-4efc-b895-1669adc3db62.png',
      smoke: '/upload/file/diamondItem/image/ea769bfd-d7a7-4f06-b44a-47065a0e4929.png',
    },
    local: {
      waterBucket: '/upload/file/diamondItem/image/e04954bc-ef24-49ef-b431-bc4bae703277.png',
      bomb: '/upload/file/diamondItem/image/b1b905b1-086c-478f-a73a-bf15f125586b.png',
      poop: '/upload/file/diamondItem/image/eff98a22-e5ec-4d39-9307-8fdf1207324c.png',
      jetFighter: '/upload/file/diamondItem/image/f8791eac-ff03-4103-8d3b-da1a7f67c5af.png',
      smoke: '/upload/file/diamondItem/image/e5a53fc5-db36-4978-9515-0d96146ef6d3.png',
    },
  };

  let imageUrl;
  if (NEXT_PUBLIC_RUNTIME_ENV === 'staging') {
    imageUrl = imageUrls.staging[imageName];
  } else if (NEXT_PUBLIC_RUNTIME_ENV === 'production') {
    imageUrl = imageUrls.production[imageName];
  } else {
    imageUrl = imageUrls.local[imageName];
  }
  return imageUrl;
};

export default getImage;
